import client from '@/plugins/axios.js'

export default  {
  dealers(){
    return new Promise((resolve,reject)=>{
      client({requiresAuth:true}).get('/api/drm/dealers').then((res)=>{
        resolve(res.data.data.primaryObject)
      }).catch((err)=>{
        console.log(err)
        reject(err)
      })
    })
  },
  dealer(id){
    return new Promise((resolve,reject)=>{
      client({requiresAuth:true}).get('/api/drm/dealer/'+id).then((res)=>{
        resolve(res.data.data.primaryObject)
      }).catch((err)=>{
        console.log(err)
        reject(err)
      })
    })
    
  },
  saveDealer(id, payload){
    return new Promise((resolve,reject)=>{
      client({requiresAuth:true}).post('/api/drm/dealer/'+id, payload).then((res)=>{
        resolve(res.data.data.primaryObject)
      }).catch((err)=>{
        reject(err)
      })
    })
  },
  tags(){
    // https://apidev.perfecthome.com/api/drm/allTags
    return new Promise((resolve,reject)=>{
      client({requiresAuth:true}).get('/api/drm/allTags').then((res)=>{
        resolve(res.data.data.primaryObject)
      }).catch((err)=>{
        console.log(err)
        reject(err)
      })
    })
    
  },
  addTag( payload){
    // https://apidev.perfecthome.com/api/drm/allTags
    return new Promise((resolve,reject)=>{
      client({requiresAuth:true}).post('/api/drm/addTag', payload).then((res)=>{
        resolve(res.data.data.primaryObject)
      }).catch((err)=>{
        console.log(err)
        reject(err)
      })
    })
    
  },
  addTagToDealer( id, hcid){
    // https://apidev.perfecthome.com/api/drm/allTags
    return new Promise((resolve,reject)=>{
      client({requiresAuth:true}).post('/api/drm/dealer/'+hcid+'/tag/'+id+'/add', {}).then((res)=>{
        resolve(res.data.data.primaryObject)
      }).catch((err)=>{
        console.log(err)
        reject(err)
      })
    })
    
  },
  removeTagFromDealer( id,hcid){
    // https://apidev.perfecthome.com/api/drm/allTags
    return new Promise((resolve,reject)=>{
      client({requiresAuth:true}).post('/api/drm/dealer/'+hcid+'/tag/'+id+'/remove', {}).then((res)=>{
        resolve(res.data.data.primaryObject)
      }).catch((err)=>{
        console.log(err)
        reject(err)
      })
    })
    
  },
  loadPrimaryCodeForDealer(payload){
    return new Promise((resolve,reject)=>{
      client({requiresAuth:true}).get('/api/dealer/shopifyPrimaryCode/'+payload)
        .then((res)=>{
          resolve(res.data.data)
        })
        .catch((err)=>{
          reject(err)
        })
    });
    
  },
  loadHostessCodesForDealer(){
    return new Promise((resolve,reject)=>{
      
      client({requiresAuth:true}).get('/api/dealer/shopifyCodes/my-list')
        .then((res)=>{
          resolve(res.data.data)
        })
        .catch((err)=>{
          reject(err)
        })
    });
    
  }
  
}
